module.exports = __webpack_public_path__ + "media/images/document-icon-469862af.png";